// wraps a function thats used as event handler to always call
// preventDefault on event object, i.e. for <a href="#" onClick={...}> stuff
const preventDefault = (handler) => (e) => {
  e.preventDefault();
  return handler();
};

export default preventDefault;
